import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';

import { Observable } from 'rxjs';

@Injectable()
export class MateriaisService {
    urlObterQuestoes: string;
    codigoModuloMateriais = 13;
    analiseAtual: any = null;
    idPaginaMateriais: string = "962";
    resumoAnalise: any;
    TIPO_ARQUIVO_TOMADA = 13;

    constructor(public http: HttpClient,
        private gestaoPcaService: GestaoPcaService,
        private utilService: UtilService) {
    }

    public obterIdPaginaMateriais() {
        return this.idPaginaMateriais;
    }

    //inventario sintetico de materiais de consumo - regra 2 
    public obterListaAnalisesJur(codModulo): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public obterListaAnalises(codModulo): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public listarMateriaisConsumo(): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/listarInventarioMaterialConsumo?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public listarMateriaisConsumoPorPag(pag): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/listarInventarioMaterialConsumoPorPag?idPca=" + this.gestaoPcaService.getPCA().id + "&pag=" + pag;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarMateriaisConsumo(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/salvarInventarioMaterialConsumo?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarMateriaisConsumo(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/finalizarInventarioMaterialConsumo?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public removerMateriaisConsumo(idInventario): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/deletarInventarioMaterialConsumo/" + idInventario;
        return this.utilService.deleteJSON(this.urlObterQuestoes);
    }

    public deletarMateriaisConsumoLista(jsonList): Observable<any> {
        let urlObtencaoDados = "gestaoMateriaisExclusao/excluirMaterialConsumoLista";
        return this.utilService.postJSON(urlObtencaoDados, jsonList);
    }

    //regra 3 a 5 - Inventario sintetico de bens patromoniais moveis, imoveis e intangiveis
    public listarInventarios(cdAnalise): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/listarInventarios?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public listarInventariosPorPag(cdAnalise, pag): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/listarInventariosPorPag?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise + "&pag=" + pag;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarInventarios(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/salvarInventarios?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarInventarios(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/finalizarInventarios?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public removerInventarios(idInventario, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/deletarInventario?idAnalise=" + idInventario + "&cdAnalise=" + cdAnalise;
        return this.utilService.deleteJSON(this.urlObterQuestoes);
    }

    public deletarInventarioLista(jsonList, cdAnalise): Observable<any> {
        let urlObtencaoDados = "gestaoMateriaisExclusao/excluirInventariosLista?cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(urlObtencaoDados, jsonList);
    }

    //regra 6 a 7 - Alienacoes patrimoniais
    public listarAlienacoes(cdAnalise): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/listarAlienacoes?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public listarAlienacoesPorPag(cdAnalise, pag): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/listarAlienacoesPorPag?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise + "&pag=" + pag;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarAlienacoes(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/salvarAlienacoes?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarAlienacoes(jsonObjeto, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/finalizarAlienacoes?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public deletarAlienacao(idInventario, cdAnalise): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/deletarAlienacao?idAnalise=" + idInventario + "&cdAnalise=" + cdAnalise;
        return this.utilService.deleteJSON(this.urlObterQuestoes);
    }

    public deletarAlienacaoLista(jsonList, cdAnalise): Observable<any> {
        let urlObtencaoDados = "gestaoMateriaisExclusao/excluirAlienacaoLista?cdAnalise=" + cdAnalise;
        return this.utilService.postJSON(urlObtencaoDados, jsonList);
    }

    //regra 8 - bens e doações
    public listarBaixaBensDoacao(): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/listarBaixaBensDoacao?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public listarBaixaBensDoacaoPorPag(pag): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/listarBaixaBensDoacaoPorPag?idPca=" + this.gestaoPcaService.getPCA().id + "&pag=" + pag;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarBaixaBensDoacao(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/salvarBaixaBensDoacao?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarBaixaBensDoacao(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/finalizarBaixaBensDoacao?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public cargaBaixaBensDoacao(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "gestaoMateriais/cargaBaixaBensDoacao?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public deletarBaixaBensDoacao(idInventario) {
        let urlObtencaoDados: string = "gestaoMateriais/deletarBaixaBensDoacao/" + idInventario;
        return this.utilService.deleteJSON(urlObtencaoDados);
    }

    public deletarBaixaLista(jsonList): Observable<any> {
        let urlObtencaoDados = "gestaoMateriaisExclusao/excluirBaixaLista";
        return this.utilService.postJSON(urlObtencaoDados, jsonList);
    }

    public obterPreviewCertificado(): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/obterCertificado?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }


    // -------------------------------------------------------- Analista ------------------------------------------- //
    // RGN02
    public obterSaldosContabeis(): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/obterSaldosContabeis?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarSaldosContabeis(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/salvarSaldosContabeis";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public submeterSaldosContabeis(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/submeterSaldosContabeis";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    // RGN03
    public obterBaixaXSaldoAtual(): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/obterBaixaXSaldoAtual?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarBaixaXSaldoAtual(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/salvarBaixaXSaldoAtual";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public submeterBaixaXSaldoAtual(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/submeterBaixaXSaldoAtual";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    // RGN04
    public obterBaixaXAquisicao(): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/obterBaixaXAquisicao?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarBaixaXAquisicao(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/salvarBaixaXAquisicao";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public submeterBaixaXAquisicao(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/submeterBaixaXAquisicao";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    // RGN05
    public obterAlienacaoDoacoesRealizadas(): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/obterAlienacaoDoacoesRealizadas?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarAlienacaoDoacoesRealizadas(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/salvarAlienacaoDoacoesRealizadas";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarAlienacaoDoacoesRealizadas(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/finalizarAlienacaoDoacoesRealizadas";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    // e RGN06
    public obterReconhecimentoAlien(): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/obterReconhecimentoAlienacao?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarReconhecimentoAlien(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/salvarReconhecimentoAlienacao";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarReconhecimentoAlien(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/finalizarReconhecimentoAlienacao";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public obterAnaliseTabelasXBalancetes(): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/obterAnaliseTabelasXBalancetes?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarAnaliseTabelasXBalancetes(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/salvarAnaliseTabelasXBalancetes";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public submeterAnaliseTabelasXBalancetes(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "analiseGestaoMateriais/submeterAnaliseTabelasXBalancetes";
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

}


// WEBPACK FOOTER //
// ./src/providers/materiais-service.ts